import { format } from 'date-fns';

const mapped = {
  format(date, mask = 'dd/MM/yyyy') {
    return format(date, mask);
  },
};

export default mapped;
